import App from './App.vue'
import router from './router'
import store from './store.js'
import Vidle from 'v-idle-3'
import { createSSRApp } from 'vue'
import FloatingVue from 'floating-vue' //tooltip
import VueClipboard from 'vue3-clipboard'
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/css/index.css';
import Popper from "vue3-popper";

import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { far } from "@fortawesome/free-regular-svg-icons"
library.add(fas, far);

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";

import * as Sentry from "@sentry/vue";

export default async function () {
    const app = createSSRApp(App)
    router.beforeEach((to, from, next) => {
        let isAuthenticated = store.state.isUserLoggedIn;
        let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        if (!isAuthenticated) {
            if (requiresAuth) next({ name: 'login' });
            else next();
        } else {
            if (requiresAuth) {
                let isAdmin = store.state.user?.isAdmin ? store.state.user.isAdmin : false;
                let isSuperAdmin = store.state.user?.isSuperAdmin ? store.state.user.isSuperAdmin : false;
                let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
                let requiresSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
                if (requiresAdmin && !isAdmin) next({ name: "home" }); else {
                    if (requiresSuperAdmin && !isSuperAdmin) next({ name: "home" }); else next()
                };
            } else {
                if (to.name.includes('public') || to.name.includes('logout')) {
                    next();
                } else {
                    next({ name: "home" })
                }
            };
        }
    });
    app.use(router)
    app.use(store)
    app.use(Vidle)
    app.component("font-awesome-icon", FontAwesomeIcon)
    app.component('Loading', Loading);
    app.use(FloatingVue)
    app.use(VueClipboard, {
        autoSetContainer: true,
        appendToBody: true,
    })
    app.component("Popper", Popper);
    app.component("VueDatePicker", VueDatePicker);
    app.use(VueSweetalert2);
    app.use(VueAwesomePaginate);
    if (!import.meta.env.SSR) {
        const { default: DataTable } = await import('datatables.net-vue3');
        const { default: DataTablesFactory } = await import('datatables.net-bs5');
        const { default: FixedHeader } = await import('datatables.net-fixedheader-bs5');

        // Register FixedHeader plugin with DataTables factory
        DataTable.use(DataTablesFactory);
        DataTable.use(FixedHeader);

        app.component('DataTable', DataTable);

        const { default: Multiselect } = await import('vue-multiselect');
        await import('vue-multiselect/dist/vue-multiselect.css');
        app.component('VueMultiselect', Multiselect);
    }
    if (!import.meta.env.SSR) {
        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN,
            integrations: [
                Sentry.browserTracingIntegration({ router }),
            ]
        });
    }
    return { app, router, store, Vidle }
}